// extracted by mini-css-extract-plugin
export default {"ul":"LessonsMenu_ul__nAZ6+","ol":"LessonsMenu_ol__t4yvn"};